import * as React from "react";
import "./Transition.scss";
import { GovIconSVG } from "./GovIconSVG";
import { ProviderIconSVG } from "./ProviderIconSVG";
import { PrivateIconSVG } from "./PrivateIconSVG";
import { CommunityIconSVG } from "./CommunityIconSVG";

export const defaultTransitionCards = [
    { icon: <GovIconSVG />, title: "Government Programs", italicText: "Scanning..." },
    { icon: <ProviderIconSVG />, title: "Private Programs", italicText: "Scanning..." },
    { icon: <PrivateIconSVG />, title: "Commercial Programs", italicText: "Scanning..." },
    { icon: <CommunityIconSVG />, title: "Community Programs", italicText: "Scanning..." },
];

export const Transition = ({
    isTransitioning,
    children,
    cards = defaultTransitionCards,
    title = "Hold tight, we are crunching the numbers...",
}) => {
    const renderCards = cards.map((card, i) => {
        return (
            <div className="transition__card" key={i}>
                <div className="transition__card-icon">{card.icon}</div>
                <p className="transition__checking">{card.italicText}</p>
                <h4 className="transition__card-title">{card.title}</h4>
            </div>
        );
    });

    return (
        <>
            {isTransitioning && (
                <div className={`transition ${isTransitioning && "transition--open"}`}>
                    <h2>{title}</h2>
                    <div className="dot-loader">
                        <div className="dot-loader-dot dot1" />
                        <div className="dot-loader-dot dot2" />
                        <div className="dot-loader-dot dot3" />
                    </div>

                    <div className="transition__cards">{renderCards}</div>
                </div>
            )}
            {!isTransitioning && children}
        </>
    );
};
